import { AfterViewInit, Component, ElementRef, Inject, OnDestroy, Optional, Renderer2 } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { BaseDialog } from '../base.dialog';
import { ClientInterface } from '../../../../core';
import { ParentEvents } from '../../../utils/parent-events.service';

export interface ConfirmContractDialogData {
    client: ClientInterface;
    isFirstContract: boolean;
    only: boolean;
}

@Component({
    templateUrl: './confirm-contract.dialog.html',
    styleUrls: ['./confirm-contract.dialog.scss'],
})
export class ConfirmContractDialog extends BaseDialog implements AfterViewInit, OnDestroy {
    constructor(
        el: ElementRef,
        parentEvents: ParentEvents,
        renderer: Renderer2,
        private dialogRef: MatDialogRef<ConfirmContractDialog>,
        @Inject(MAT_DIALOG_DATA)
        public data: ConfirmContractDialogData
    ) {
        super(parentEvents, el, renderer);
    }

    onClose() {
        this.dialogRef.close(false);
    }
}
